import { css } from "@emotion/react";
import * as React from "react";
import {
    FaColumns,
    FaFileExcel,
    FaSortAlphaDown,
    FaSortAlphaDownAlt,
    FaSortNumericDown,
    FaSortNumericDownAlt
} from "react-icons/fa";
import writeXlsxFile from "write-excel-file";
//import { useUIStore } from "../store/ui-store";
import { StickyTable } from "@podtrac/common/components/StickyTable";

const sorts = {
    [Number]: {
        ascending: value => (a, b) => b.summary ? 1 : value(a) - value(b),
        descending: value => (a, b) => b.summary ? 1 : value(b) - value(a)
    },
    [String]: {
        ascending: value => (a, b) => {
            const A = value(a)?.toUpperCase();
            const B = value(b)?.toUpperCase();
            if (b.summary) return 1;
            if (A < B) {
                return -1;
            }
            if (A > B) {
                return 1;
            }

            return 0;
        },
        descending: value => (a, b) => {
            const A = value(a)?.toUpperCase();
            const B = value(b)?.toUpperCase();
            if (b.summary) return 1;
            if (A < B) {
                return 1;
            }
            if (A > B) {
                return -1;
            }

            return 0;
        }
    },
    [Date]: {
        ascending: value => (a, b) => b.summary ? 1 : value(a) - value(b),
        descending: value => (a, b) => b.summary ? 1 : value(b) - value(a)
    }
};
export default function QueryDataTable({
    config,
    configVary,
    query,
    filter = () => true,
    sortControls,
    children,
    chart
}) {
    const columnsRef = React.useRef(),
        closeColumnMenu = () => columnsRef.current?.removeAttribute("open");

    const visibleColumns = null;
    //const visibleKey = [config.sheetName, configVary].filter(Boolean),
    //    [visibleColumns, toggleVisibleColumn] = useUIStore(state => [
    //        path(visibleKey, state.visibleColumns),
    //        state.toggleVisibleColumn(visibleKey)
    //    ]);

    //console.log(visibleColumns);

    const [sort, setSort] = React.useState(config.sortColumn),
        column = React.useMemo(() => config.schema.find(s => s.column == sort), [config, sort]);
    const [direction, setDirection] = React.useState(config.sortDirection);
    const { isLoading, isIdle, data = [] } = query;
    const sorted = React.useMemo(
        () =>
            column
                ? data
                      .filter(filter)
                      .sort(
                          (column.sort?.[direction] ?? sorts[column.type][direction])(column.value)
                      )
                : data,
        [data, column, direction, filter]
    );

    const radioChange = event => setDirection(event.target.value);

    return config ? (
        <>
            <div
                css={css`
                    display: flex;

                    color: #555;
                    align-items: center;
                    margin-top: 1rem;
                    gap: 0.5em;
                    font-size: 0.75em;
                    margin-bottom: -0.5rem;
                    label {
                        display: flex;
                        align-items: center;
                    }
                    h2 {
                        flex: 1;
                        margin: 0;
                    }
                    select {
                        color: #555;
                    }
                `}
            >
                <h2>{config.sheetName}</h2>
                {children}
                {sortControls ? (
                    <>
                        Sort by
                        <select value={sort} onChange={event => setSort(event.target.value)}>
                            {config.schema
                                .filter(c => !!sorts[c.type] && !c.nosort)
                                .map(c => (
                                    <option key={c.column} value={c.column}>
                                        {c.html?.column ?? c.column}
                                    </option>
                                ))}
                        </select>
                        <label title="lowest to highest">
                            <input
                                type="radio"
                                value="ascending"
                                checked={direction == "ascending"}
                                onChange={radioChange}
                            />
                            {column?.type == String ? <FaSortAlphaDown /> : <FaSortNumericDown />}
                        </label>
                        <label title="highest to lowest">
                            <input
                                type="radio"
                                value="descending"
                                checked={direction == "descending"}
                                onChange={radioChange}
                            />
                            {column?.type == String ? (
                                <FaSortAlphaDownAlt />
                            ) : (
                                <FaSortNumericDownAlt />
                            )}
                        </label>
                        {visibleColumns ? (
                            <details
                                title="Select visible columns"
                                ref={columnsRef}
                                onToggle={event => {
                                    if (event.currentTarget.open) {
                                        document.body.addEventListener("click", closeColumnMenu);
                                    } else {
                                        document.body.removeEventListener("click", closeColumnMenu);
                                    }
                                }}
                                css={css`
                                    position: relative;
                                    margin-left: 1em;
                                    summary {
                                        list-style: none;
                                        display: flex;
                                        cursor: default;
                                        color: #555;
                                        align-items: center;
                                        gap: 0.25rem;
                                        border: none;
                                        background: none;
                                        border-radius: 1em;
                                        padding: 0.25em 0.5em;
                                        transition: all 0.2s;
                                        user-select: none;
                                        &:hover {
                                            background: #eee;
                                            color: #000;
                                        }
                                    }
                                    > div {
                                        position: absolute;
                                        background: #fff;
                                        white-space: nowrap;
                                        padding: 1em;
                                        z-index: 100;
                                        border: 1px solid #eee;
                                        box-shadow: 2px 2px 3px 0px #eee;

                                        label: {
                                            display: flex;
                                            align-items: center;
                                        }
                                    }
                                `}
                            >
                                <summary
                                    onClick={event =>
                                        columnsRef.current?.open && event.stopPropagation()
                                    }
                                >
                                    <FaColumns /> Columns
                                </summary>
                                <div onClick={event => event.stopPropagation()}>
                                    {config.schema.map((c, i) => (
                                        <label key={c.column}>
                                            <input
                                                type="checkbox"
                                                checked={i == 0 || !!visibleColumns?.[c.column]}
                                                disabled={i == 0}
                                                onChange={() => toggleVisibleColumn(c.column)}
                                            />
                                            {c.html?.column ?? c.column}
                                        </label>
                                    ))}
                                </div>
                            </details>
                        ) : null}
                    </>
                ) : null}

                {isLoading || isIdle ? null : (
                    <button
                        title="Export table"
                        css={css`
                            display: flex;
                            color: #555;
                            align-items: center;
                            gap: 0.25rem;
                            margin-left: 1em;
                            border: none;
                            background: none;
                            border-radius: 1em;
                            padding: 0.25em 0.5em;
                            transition: all 0.2s;
                            &:hover {
                                background: #eee;
                                color: #000;
                            }
                        `}
                        onClick={() =>
                            writeXlsxFile([sorted], {
                                fileName: `${config.sheetName}.xlsx`,
                                schema: [config.schema],
                                sheets: [config.sheetName],
                                stickyRowsCount: config.stickyRows,
                                stickyColumnsCount: config.stickyColumns
                            })
                        }
                    >
                        <FaFileExcel fill="green" /> Export
                    </button>
                )}
            </div>
            {chart}
            <StickyTable>
                <thead>
                    <tr>
                        {config.schema
                            .filter(c => (visibleColumns ? visibleColumns[c.column] : true))
                            .map((c, i) => (
                                <th
                                    key={i}
                                    onClick={
                                        c.nosort
                                            ? null
                                            : () => {
                                                  setSort(current => {
                                                      // if the current column is already selected then change direction
                                                      if (current == c.column) {
                                                          setDirection(
                                                              direction == "ascending"
                                                                  ? "descending"
                                                                  : "ascending"
                                                          );
                                                      }
                                                      return c.column;
                                                  });
                                              }
                                    }
                                    style={{ cursor: c.nosort ? "default" : "pointer" }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "0.5em"
                                        }}
                                    >
                                        {c.html?.column ?? c.column}
                                        {c.column == sort ? (
                                            direction == "ascending" ? (
                                                c.type == String ? (
                                                    <FaSortAlphaDown style={{ flexShrink: 0 }} />
                                                ) : (
                                                    <FaSortNumericDown style={{ flexShrink: 0 }} />
                                                )
                                            ) : c.type == String ? (
                                                <FaSortAlphaDownAlt style={{ flexShrink: 0 }} />
                                            ) : (
                                                <FaSortNumericDownAlt style={{ flexShrink: 0 }} />
                                            )
                                        ) : null}
                                    </div>
                                </th>
                            ))}
                    </tr>
                </thead>
                <tbody>
                    {isLoading || isIdle ? (
                        <tr>
                            {config.schema
                                .filter(c => (visibleColumns ? visibleColumns[c.column] : true))
                                .map((c, i) => (
                                    <td key={i} style={c.html?.style}>
                                        <div className="placeholder" />
                                    </td>
                                ))}
                        </tr>
                    ) : (
                        sorted.map((d, i) =>
                            React.createElement(
                                "tr",
                                {
                                    key: config.key(d, i),
                                    className: d.summary ? "summary" : undefined,
                                    ...(config.rowProps ? config.rowProps(d, i) : {})
                                },
                                config.schema
                                    .filter(c => (visibleColumns ? visibleColumns[c.column] : true))
                                    .map((c, i) =>
                                        React.createElement(
                                            c.html?.component ?? "td",
                                            {
                                                key: i,
                                                style: c.html?.style,
                                                data: d,
                                                value: c.value(d)
                                            },
                                            c.html?.component ? undefined : c.value(d)
                                        )
                                    )
                            )
                        )
                    )}
                </tbody>
            </StickyTable>

            {/*<pre>{JSON.stringify({ visibleColumns }, null, 2)}</pre>*/}
        </>
    ) : null;
}
